module.exports = __webpack_public_path__ + "img/logo.7f9a19a2.png";